import { BranchType } from '../interfaces/delivery-company/branches';

/**
 * Utility functions for checking branch-based permissions
 */

/**
 * Check if an item can be edited based on its branch
 * Items can only be edited if they belong to the current branch
 */
export const canEditItem = (
  itemBranch: BranchType | null | undefined,
  currentBranch: BranchType | null | undefined
): boolean => {
  // If no branch context, allow editing (for backwards compatibility)
  if (!currentBranch) {
    return true;
  }

  // If item has no branch, deny editing (should not happen in normal cases)
  if (!itemBranch) {
    return false;
  }

  // Can only edit items from the current branch
  return itemBranch.id === currentBranch.id;
};

/**
 * Check if an item can be deleted based on its branch
 * Items can only be deleted if they belong to the current branch
 */
export const canDeleteItem = (
  itemBranch: BranchType | null | undefined,
  currentBranch: BranchType | null | undefined
): boolean => {
  return canEditItem(itemBranch, currentBranch);
};

/**
 * Check if items are from the current branch
 */
export const isCurrentBranch = (
  itemBranch: BranchType | null | undefined,
  currentBranch: BranchType | null | undefined
): boolean => {
  if (!itemBranch || !currentBranch) {
    return true; // Assume current if no branch info
  }
  return itemBranch.id === currentBranch.id;
};

/**
 * Get a tooltip message explaining why an action is disabled
 */
export const getDisabledActionTooltip = (
  itemBranch: BranchType | null | undefined,
  currentBranch: BranchType | null | undefined,
  action = 'modify'
): string => {
  if (!itemBranch || !currentBranch) {
    return `Cannot ${action} this item`;
  }

  if (itemBranch.id !== currentBranch.id) {
    return `Cannot ${action} items from branch "${itemBranch.name}". Switch to that branch to ${action} this item.`;
  }

  return '';
};


